import { ClaudeTemplate } from "../types";
import { BASE, ENTER_ACCOUNT } from "./googleAdsShared";

/** Google Ads Performance Max. */
export const googleAdsPmaxTemplate: ClaudeTemplate = {
  ...BASE,
  id: "google-ads-pmax",
  hierarchy:
    "Cuenta (MCC) → Customer account → Campaign (Performance Max) → Asset groups",
  steps: `${ENTER_ACCOUNT}
### 2. Campaign Performance Max
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, "New campaign":
   - Objective: Sales, Leads o Website traffic según {{goal.kpi}}.
   - Conversion goals: los de la cuenta del cliente. Si el objetivo es CPA/CPL y no hay conversiones configuradas, para y pregunta.
   - Campaign type: **Performance Max**.
   - Campaign name: {{names.order}}
   - Budget: diario = {{goal.budget}} / número de días entre {{goal.startDate}} y {{goal.endDate}} (redondea a la baja y dime el cálculo), o total de campaña si la cuenta lo permite.
   - Bidding: Maximize conversions / conversion value; Target CPA en torno a {{goal.netUnitCost}} solo si las notas lo piden.
   - Locations: {{target.geography}} (país {{goal.country}}). Languages: {{target.language}}.
   - Start / end date: {{goal.startDate}} → {{goal.endDate}}.
   - Final URL expansion: desactivado, salvo que las notas digan otra cosa.

### 3. Asset group
1. Asset group name: {{names.line}}
2. Final URL con UTM: bloque "URLs de destino".
3. Imágenes, logos y vídeos: bloque "Creatividades". Titulares, descripciones, nombre de empresa ({{brand}}) y CTA: bloque "Copies". Si faltan mínimos (imágenes, titulares largos/cortos, descripciones), dime cuáles.
4. Audience signal: {{target.audience}} / {{target.interests}} (edad {{target.age}}, sexo {{target.gender}} como señal, no como restricción).
5. Al terminar, **pausa la campaña** y avísame.
`,
};
